import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@app/App';
import { initMocks } from '@mocks/index';
import 'antd/dist/reset.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import '@/styles/global.css';

async function bootstrap() {
  // Enable mocks when explicitly requested, or by default in dev when no API base URL is configured
  const explicit = import.meta.env.VITE_USE_MOCKS;
  const useMocks =
    explicit === 'true' ||
    (explicit !== 'false' && import.meta.env.DEV && !import.meta.env.VITE_API_BASE_URL);
  if (useMocks) {
    await initMocks();
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

void bootstrap();
